var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.610056,
    y: 0.329782,
    width: 27.0422,
    height: 27.0422,
    rx: 8.90413,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.610056,
    y: 0.329782,
    width: 27.0422,
    height: 27.0422,
    rx: 8.90413,
    stroke: "#E2E2EA",
    strokeWidth: 0.659565
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.2398 13.7374C15.9094 13.7374 17.2628 12.384 17.2628 10.7144C17.2628 9.04485 15.9094 7.69141 14.2398 7.69141C12.5702 7.69141 11.2168 9.04485 11.2168 10.7144C11.2168 12.384 12.5702 13.7374 14.2398 13.7374Z",
    stroke: "#A461D8",
    strokeWidth: 0.989347,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.432 19.783C19.432 17.4432 17.1043 15.5508 14.2384 15.5508C11.3726 15.5508 9.04492 17.4432 9.04492 19.783",
    stroke: "#A461D8",
    strokeWidth: 0.989347,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileDark);
export default __webpack_public_path__ + "static/media/profile-dark.acf852179694280a158cd99ac9f67fd4.svg";
export { ForwardRef as ReactComponent };